import React from 'react'

export default (props) =>
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#8ECE93"/>
        <path d="M6.21082 12.0814L10.1664 15.7883L18.4569 7.78833" stroke="white" strokeWidth="2"/>
    </svg>
